import React from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import Login from './pages/login';
import Home from './pages/home';
import ListForms from './pages/listForms';
import CreateTemplate from './pages/createTemplate';
import Tabulation from './pages/tabulation';
import Pendency from './pages/pendency'
import CreateSkills from './pages/createSkills';
import UpdateForm from './pages/updateForm';
import CreateForm from './pages/createForm';
import { Header } from './components/Header';
import style from './style.module.scss';


// Layout padrão que engloba Header, Sidebar e o conteúdo via Outlet
const DefaultLayout: React.FC = () => {
  const [activeSidebar, setActiveSidebar] = React.useState(true);

  const toggleActiveSidebar = () => {
    setActiveSidebar(!activeSidebar)
  }

  return (
    <div className={style.contentContainer}>
      <Header toggleActiveSidebar={toggleActiveSidebar} activeSidebar={activeSidebar} />
      {/* Conteúdo das rotas filhas */}
      <Home toggleActiveSidebar={toggleActiveSidebar} activeSidebar={activeSidebar} />
      <section className={style.contentContainerSection} onClick={() => { if (activeSidebar) { toggleActiveSidebar() } }}>
        <Outlet />
      </section>
    </div>
  );
};

const MainRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/section" element={<DefaultLayout />}>
        {/* Rota padrão da página Home */}
        <Route index element={<ListForms />} />
        <Route path="createForm" element={<CreateForm create={true} />} />
        <Route path="updateForm" element={<UpdateForm create={false} />} />
        <Route path="listForms" element={<ListForms />} />
        <Route path="createTemplate" element={<CreateTemplate />} />
        <Route path="tabulation" element={<Tabulation />} />
        <Route path="pendency" element={<Pendency />} />
        <Route path="createSkills" element={<CreateSkills />} />
      </Route>
    </Routes>
  );
};

export default MainRoutes;
